import { render, staticRenderFns } from "./LoginCatalogScanner.vue?vue&type=template&id=06630dc4&scoped=true&"
import script from "./LoginCatalogScanner.vue?vue&type=script&lang=js&"
export * from "./LoginCatalogScanner.vue?vue&type=script&lang=js&"
import style0 from "./LoginCatalogScanner.vue?vue&type=style&index=0&id=06630dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06630dc4",
  null
  
)

export default component.exports